export default __webpack_public_path__ + "static/media/codegen-prompt.935876ab.md";